import React, { useState } from 'react';
import { SendIcon } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => setSubmitSuccess(false), 5000);
    }, 1500);
  };
  return <form onSubmit={handleSubmit} className="space-y-7" data-id="element-70">
      {submitSuccess && <div className="bg-green-50 border border-green-200 text-green-800 rounded-md p-5 mb-6 text-center" data-id="element-71">
          <p className="font-medium" data-id="element-72">Thank you for your message.</p>
          <p className="text-sm mt-1" data-id="element-73">We'll be in touch with you shortly.</p>
        </div>}
      <div data-id="element-74">
        <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-75">
          Name
        </label>
        <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 bg-gray-50" placeholder="Your name" data-id="element-76" />
      </div>
      <div data-id="element-77">
        <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-78">
          Email
        </label>
        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 bg-gray-50" placeholder="Your email address" data-id="element-79" />
      </div>
      <div data-id="element-80">
        <label htmlFor="subject" className="block text-gray-700 font-medium mb-2" data-id="element-81">
          Subject
        </label>
        <select id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 bg-gray-50 appearance-none" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23666666'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 1rem center',
        backgroundSize: '1rem'
      }} data-id="element-82">
          <option value="" data-id="element-83">Select a service</option>
          <option value="Brand Storytelling" data-id="element-84">Brand Storytelling</option>
          <option value="Content Creation" data-id="element-85">Content Creation</option>
          <option value="Strategy & Campaigns" data-id="element-86">Strategy & Campaigns</option>
          <option value="Other Services" data-id="element-87">Other Services</option>
        </select>
      </div>
      <div data-id="element-88">
        <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-89">
          Message
        </label>
        <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-900 bg-gray-50" placeholder="Tell us about your project or inquiry" data-id="element-90"></textarea>
      </div>
      <button type="submit" disabled={isSubmitting} className="flex items-center justify-center space-x-2 accent-bg text-white hover:bg-opacity-90 px-8 py-4 rounded-md w-full transition-colors disabled:bg-gray-400 mt-4" data-id="element-91">
        {isSubmitting ? <span data-id="element-92">Sending...</span> : <>
            <SendIcon size={18} data-id="element-93" />
            <span data-id="element-94">Send Message</span>
          </>}
      </button>
    </form>;
}